<template>
  <div>
    <v-container>
      <v-layout>
        <v-flex shrink>
          <h2 class="mt-0">
            Influencers
          </h2>
        </v-flex>
        <v-flex class="text-xs-right">
          <v-btn outline color="primary" @click="showAdd = true">
            <v-icon class="mr-2">add</v-icon> {{ $t('Add') }}
          </v-btn>
        </v-flex>
      </v-layout>

      <div v-if="loading" class="spinner text-xs-center py-5 ">
        <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
      </div>
      <div
        v-else-if="influencers.length == 0"
        class="grey lighten-4 py-4 text-xs-center"
        style="border-radius: 10px"
      >
        No influencer
      </div>
      <template v-else>
        <template v-for="(influencer, index) in influencers">
          <div class="z-border-red pa-2 mb-2" :key="'influencer_' + index">
            <v-layout>
              <v-flex shrink>
                <v-avatar class="mr-2">
                  <img v-if="influencer.jsonvalue" :src="influencer.jsonvalue.image_url" />
                </v-avatar>
              </v-flex>
              <v-flex>
                <div class="font-weight-bold">{{ influencer.userid }}</div>

                <!-- Orders: 100 order(s) -->
              </v-flex>
              <v-flex shrink class="text-xs-right">
                <v-btn
                  fab
                  small
                  outline
                  color="primary"
                  @click="
                    currentInfluencer = influencer
                    showEdit = true
                  "
                  ><v-icon>edit</v-icon></v-btn
                >
                <v-btn fab small outline color="primary" @click="deleteInfluencer(influencer)"
                  ><v-icon>delete</v-icon></v-btn
                >
              </v-flex>
            </v-layout>
          </div>
        </template>
      </template>
    </v-container>

    <influencer-manage
      v-if="showAdd"
      v-model="showAdd"
      :influencers="influencers"
      @saveInfluencer="addInfluencer"
    ></influencer-manage>

    <influencer-manage
      v-if="showEdit && currentInfluencer"
      v-model="showEdit"
      :data="currentInfluencer"
      :influencers="influencers"
      @saveInfluencer="editInfluencer"
    ></influencer-manage>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import InfluencerManage from './InfluencerManage'
export default {
  components: {
    InfluencerManage
  },
  data() {
    return {
      showAdd: false,
      showEdit: false,
      influencers: [],
      loading: true,
      currentInfluencer: null
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  async mounted() {
    this.loading = true
    var response = await this.getchillpainai_influencer()
    if (response) this.influencers = response
    await this.$store.dispatch('loadCategory')
    await this.$store.dispatch('loadProducts')
    this.loading = false
  },
  methods: {
    addInfluencer({ influencer, oncomplete, onerror }) {
      var data = influencer
      data.productidlist = data.productidlist.join(',')
      data.jsonvalue = JSON.stringify(data.jsonvalue)
      var vm = this
      api.postchillpainai_influencer(
        {
          body: data,
          params: {
            pageid: this.selectedBot.pageid
          }
        },
        (error, response) => {
          if (error) {
            return false
          }
          if (response.reason) {
            onerror(response.reason)
          } else if (response.data && response.data.length > 0) {
            var influencer = response.data[0]
            influencer.productidlist =
              influencer.productidlist != null ? influencer.productidlist.split(',') : []
            try {
              influencer.jsonvalue = JSON.parse(influencer.jsonvalue)
            } catch (error) {
              influencer.jsonvalue = {}
            }
            influencer.id = vm.influencers.length
            vm.influencers.push(influencer)
            vm.influencers = vm.influencers.sort((a, b) => {
              var nameA = a.userid.toUpperCase() // ignore upper and lowercase
              var nameB = b.userid.toUpperCase() // ignore upper and lowercase

              if (nameA < nameB) {
                return -1
              }
              if (nameA > nameB) {
                return 1
              }

              // names must be equal
              return 0
            })
            oncomplete()
          }
        }
      )
    },
    editInfluencer({ influencer, oncomplete }) {
      var data = influencer
      data.productidlist = data.productidlist.join(',')
      data.jsonvalue = JSON.stringify(data.jsonvalue)
      var vm = this
      api.putchillpainai_influencer(
        {
          body: data,
          params: {
            pageid: this.selectedBot.pageid,
            userid: data.userid
          }
        },
        (error, response) => {
          if (error) {
            return false
          }
          if (data.password != '' && data.password != null) {
            vm.changeInfluencerPassword(data)
          }
          var influencer = data
          influencer.productidlist =
            influencer.productidlist != null ? influencer.productidlist.split(',') : []
          try {
            influencer.jsonvalue = JSON.parse(influencer.jsonvalue)
          } catch (error) {
            influencer.jsonvalue = {}
          }
          var index = vm.influencers.findIndex(el => {
            return el.userid == data.userid
          })
          if (index != -1) {
            vm.$set(vm.influencers, index, { ...influencer, id: vm.influencers[index].id })

            vm.influencers = vm.influencers.sort((a, b) => {
              var nameA = a.userid.toUpperCase() // ignore upper and lowercase
              var nameB = b.userid.toUpperCase() // ignore upper and lowercase

              if (nameA < nameB) {
                return -1
              }
              if (nameA > nameB) {
                return 1
              }

              // names must be equal
              return 0
            })
          }
          oncomplete().then(() => {
            vm.currentInfluencer = null
          })
        }
      )
    },
    changeInfluencerPassword(data) {
      api.putchillpainai_influencer_password(
        {
          body: {
            password: data.password
          },
          params: {
            pageid: this.selectedBot.pageid,
            userid: data.userid
          }
        },
        error => {
          if (error) {
            return false
          }
        }
      )
    },
    getchillpainai_influencer() {
      var data = {
        pageid: this.selectedBot.pageid
      }
      return new Promise((resolve, reject) => {
        api.getchillpainai_influencer(data, (error, response) => {
          if (error) reject(error)
          var influencers = response.data
            .map((el, index) => {
              var jsonvalue = el.jsonvalue
              try {
                jsonvalue = JSON.parse(jsonvalue)
              } catch (error) {
                jsonvalue = {}
              }
              return {
                id: index,
                ...el,
                productidlist: el.productidlist != null ? el.productidlist.split(',') : [],
                jsonvalue: jsonvalue
              }
            })
            .sort((a, b) => {
              var nameA = a.userid.toUpperCase() // ignore upper and lowercase
              var nameB = b.userid.toUpperCase() // ignore upper and lowercase

              if (nameA < nameB) {
                return -1
              }
              if (nameA > nameB) {
                return 1
              }

              // names must be equal
              return 0
            })
          resolve(influencers)
        })
      })
    },
    async deleteInfluencer(data) {
      var result = await this.$swal.fire({
        title: this.$t('Do you want to delete this?'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        api.deletechillpainai_influencer(
          {
            params: {
              pageid: this.selectedBot.pageid,
              userid: data.userid
            }
          },
          (error, response) => {
            if (error) console.error(error)
            var index = this.influencers.findIndex(el => {
              return el.userid == data.userid
            })
            if (index != -1) {
              this.influencers.splice(index, 1)
            }
          }
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/influencer/Influencers.vue